import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OrderState {
  [key: string]: any;
}

const initialState: OrderState = {};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    orderDetails(state, action: PayloadAction<any>) {
      return { ...state, ...action.payload };
    },
    orderReset() {
      return initialState;
    },
  },
});

export const { orderDetails, orderReset } = orderSlice.actions;
export default orderSlice.reducer;